// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"516":"team","594":"about"}[chunkId] + "." + {"516":"ec77930f","594":"af6018de"}[chunkId] + ".css";
};